// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__sWk0G","containerTop":"DefaultLayout_containerTop__RLcCe","heading":"DefaultLayout_heading__65gRN"};